

import u from "umbrellajs"
import {
  onClickOutside,
} from "plugins/vanilla-clickout"
import _merge from "lodash/merge"

// For Bootstrap 3 like dropdown
// DOM Structure should be like
// https://getbootstrap.com/docs/3.3/components/#dropdowns

interface InputSelectors {
  scope: string | HTMLElement,
  dropdown_container?: string,
  dropdown_toggle?: string | JQuery,
}

interface CompleteSelectors {
  scope: string | HTMLElement,
  dropdown_container: string,
  dropdown_toggle: string,
}

const DEFAULT_SELECTORS = {
  // Must be provided, or refuse to init
  scope:              "invalid",
  dropdown_container: ".dropdown",
  dropdown_toggle:    ".dropdown-toggle",
}

const DropdownInitDoneClass = "js--dropdown-toggle-init-done"

const init = (selectors: InputSelectors) => {
  // Ideally the dropdown from different components should be init
  // in different JS files
  // Do that later z_z

  if (selectors.scope === DEFAULT_SELECTORS.scope) {
    throw new Error("scope not provided in components/bootstrap3-like-dropdown")
  }

  const merged_selectors: CompleteSelectors = _merge({}, DEFAULT_SELECTORS, selectors)

  let $scope = u(".just-placeholder")
  if (typeof merged_selectors.scope === "string") {
    $scope = u(merged_selectors.scope)
  }
  else {
    // HTMLElement
    $scope = u(merged_selectors.scope)
  }

  $scope.find(merged_selectors.dropdown_toggle).each(( el) => {
    const $el = u(el)

    if ($el.hasClass(DropdownInitDoneClass)) { return }
    $el.addClass(DropdownInitDoneClass)

    // Hardcoded, not sure how to extract yet
    if ($el.closest(".bootstrap-select").length > 0) {
      // do nothing
      return
    }

    const $closest_dropdown_container = $el.closest(merged_selectors.dropdown_container)
    $el.on("click", (e) => {
      e.preventDefault()
      $closest_dropdown_container.toggleClass("open")
    })

    onClickOutside(el, () => {
      $closest_dropdown_container.removeClass("open")
    })
  })
}

export default {
  init,
}
